import React from 'react'
import { Grid } from '../../BuildingCharacteristics.styles'
import type { OverviewTabProps } from './OverviewTab.types'
import { useBuildingAge, useBuildingMetrics } from './hooks'
import { createFormatters } from './utils'
import {
  HeroMetricsGrid,
  DimensionsCard,
  OccupancyCard,
  StatusCard,
} from './components'

export const OverviewTab: React.FC<OverviewTabProps> = ({ building, t }) => {
  const currentYear = new Date().getFullYear()

  const ageData = useBuildingAge(building)
  const metrics = useBuildingMetrics(building)
  const { formatArea, formatHeight, formatNumber } = createFormatters(t)

  return (
    <>
      {/* Hero Metrics */}
      <HeroMetricsGrid
        footprintArea={metrics.footprintArea}
        floorCount={metrics.floorCount}
        height={metrics.height}
        buildingAge={ageData.age}
        isAgeEstimate={ageData.isEstimate}
        buildingPeriod={ageData.period}
        t={t}
      />

      {/* Detail Cards */}
      <Grid $columns={3}>
        <DimensionsCard
          footprintArea={metrics.footprintArea}
          grossFloorArea={metrics.grossFloorArea}
          height={metrics.height}
          buildingVolume={building.volume_estimate}
          buildingElevation={building.altitude_min_ref}
          formatArea={formatArea}
          formatHeight={formatHeight}
          t={t}
        />

        <OccupancyCard
          buildingCategory={building.type}
          buildingClass={building.building_class}
          popetyClassification={building.popety_classification}
          numberOfDwellings={building.number_dwellings}
          floorCount={metrics.floorCount}
          height={metrics.height}
          grossFloorArea={metrics.grossFloorArea}
          buildingUse={building.category}
          formatArea={formatArea}
          formatHeight={formatHeight}
          formatNumber={formatNumber}
          t={t}
        />

        <StatusCard
          buildingYear={ageData.year}
          buildingAge={ageData.age}
          isAgeEstimate={ageData.isEstimate}
          buildingPeriod={ageData.period}
          rawBuildingPeriod={building.building_period}
          renovationYear={building.renovation_year}
          protectedRank={building.protected_rank}
          minergie={building.minergie}
          status={building.status}
          currentYear={currentYear}
          t={t}
        />
      </Grid>
    </>
  )
}
